const GEN_SHARELINK_WINDOW_JS_URI = 'scripts/sharelink_window_4ai.15f90974.js';
const GEN_PWA_INSALL_JS_URI = 'scripts/pwa_install_4ai.8bd95f63.js';
const GEN_ONE_SUBMIT_JS_URI = 'scripts/one_submit_4ai.ea419889.js';
const GEN_CTA_CLICK_PHONE_JS_URI = 'scripts/cta_click_phone.7f5e4e4f.js';
const GEN_OBFUSCATION_URL_JS_URI = 'scripts/obfuscation_url_4ai.7f5b1295.js';

const themePath = "/wp-content/themes/abskill/dist/";

window.collections = {};

const SCRIPTS = [
    {
        'url' : GEN_SHARELINK_WINDOW_JS_URI,
        'sel' : '.share-links a',
        'col' : 'sharelinks'
    },
    {
        'url' : GEN_PWA_INSALL_JS_URI,
        'sel' : '.pwa-install-btn',
        'col' : 'addBtn'
    },
    {
        'url' : GEN_ONE_SUBMIT_JS_URI,
        'sel' : 'form',
        'col' : 'forms'
    },
    {
        'url' : GEN_CTA_CLICK_PHONE_JS_URI,
        'sel' : 'a[href^="tel:"]',
        'col' : 'clickPhone'
    },
    {
        'url' : GEN_OBFUSCATION_URL_JS_URI,
        'sel' : '[data-obfurl]',
        'col' : 'obfurls'
    }
];

let selectors = [];
for(let script of SCRIPTS ) {
    selectors.push(script.sel);
}
const obj_present = Array.from(document.querySelectorAll( selectors.join(',') ) );

for(let script of SCRIPTS ) {
    if(Array.from) {
        collections[script.col] = Array.from(document.querySelectorAll(script.sel));
        if(collections[script.col].length > 0) {
            if(script.lazy) {
                let encours = false,
                    observer = new IntersectionObserver(function(entries) {
                    for (let j = 0, lg = entries.length; j < lg; j++) {
                        if (entries[j].intersectionRatio <= 0 || encours) return;
                        encours = true;
                        new loadExt([themePath+script.url]);
                        for (let k = 0, lgt = entries.length; k < lgt; k++) {
                            observer.unobserve(entries[k].target);
                        }
                    }
                }, obsOptions);

                for (let i = 0, l = collections[script.col].length; i < l; i++) {
                    observer.observe(collections[script.col][i]);
                }

            } else {
                new loadExt([themePath+script.url]);
            }
        }
    }
}

// FONCTIONS JS Abskill
(function() {

    // Sticky header
    let lastPos = 0,
        tick = false;

    scrollPos();
    window.addEventListener('scroll', (e) => { scrollPos() }, false);
    window.addEventListener('resize', (e) => { uncheckMenuMobile() }, false);
    document.addEventListener('change', (e) => {
        // console.log(e.target);
        if(e.target.closest('.sub-menu-formations')) {
            uncheckSubmenus(e);
        }
    });
    const contKlass = ".colorblocks_container";
    if(document.querySelector(contKlass)) {
        ["resize", "load"].forEach(function(event) {
            window.addEventListener(event, function() {
                masonry(contKlass, ".colorblock", 10, 3, 3, 1);
            });
        });
    }


    function uncheckMenuMobile() {
        let menuMobile = document.querySelector('#openclose-navsite');
        const windowSize = window.innerWidth;
        if(menuMobile.checked) {
            if(windowSize >= 1280) {
                menuMobile.checked = false;
            }
        }
    }

    function uncheckSubmenus(event) {
        console.log('uncheck');
        // const subMenu = document.querySelector('.sub-menu-formations');
        let checkboxes = document.querySelectorAll('.sub-menu-formations input[type=checkbox]:checked');
        [].forEach.call(checkboxes, function(checkbox) {
            if(checkbox !== event.target) {
                checkbox.checked = false;
            }
        });
    }

    function scrollPos() {
        lastPos = window.scrollY;
        if (!tick) {
            window.requestAnimationFrame(function() {
                stickyHeader(lastPos);
                tick = false;
            });
        }
        tick = true;
    }

    function stickyHeader(pos) {
        let stickyClass = 'scroll';
        document.body.classList.toggle(stickyClass, !!pos);
    }
    /**
     * Calculate the masonry
     *
     * Calculate the average of heights of masonry-bricks and then
     * set it as the height of the masonry element.
     *
     * @since 12212018
     * @author Rahul Arora
     * @param grid       Object  The Masonry Element
     * @param gridCell   Object  The Masonry bricks
     * @param gridGutter Integer The Vertical Space between bricks
     * @param dGridCol   Integer Number of columns on big screens
     * @param tGridCol   Integer Number of columns on medium-sized screens
     * @param mGridCol   Integer Number of columns on small screens
     */
    function masonry(grid, gridCell, gridGutter, dGridCol, tGridCol, mGridCol) {
        let gs = document.querySelectorAll(grid);
        [...gs].forEach(function(g) {
            let gc = g.querySelectorAll(gridCell),
            gcLength = gc.length,
            gHeight = 0,
            i;

            for(i=0; i<gcLength; ++i) {
                gHeight+=gc[i].offsetHeight+parseInt(gridGutter);
            }

            if(window.innerWidth >= 960) {
                //g.style.height = gHeight/dGridCol + gHeight/(gcLength+1) + gChoice + "px";
                // console.log('superieur');
                g.style.height = gHeight/dGridCol + (gridGutter*(gcLength+1)) + "px";
            } else if(window.innerWidth < 960 && window.innerWidth >= 768) {
                //g.style.height = gHeight/tGridCol + gHeight/(gcLength+1) + "px";
                g.style.height = gHeight/tGridCol + (gridGutter*(gcLength+1)) + "px";
                // console.log('lol');
            } else {
                g.style.height = "auto";
                // console.log('??');
                //g.style.height = gHeight/mGridCol + gHeight/(gcLength+1) + "px"; // No mobile
            }
        });
    }
})();
